import { Button, Col, Form, Input, InputNumber, Row, Select } from "antd";
import { useEffect } from "react";
import { isArrayAndHasValue } from "utils/functions";

const ItemEdit = ({
  selectedItem,
  getTNATaskList,
  TNATaskList,
  closeDrawer,
  onUpdateItem,
  onAddNewItem,
  isDrawerOpen,
  userList,
  getUserList,
}) => {
  const [editForm] = Form.useForm();
  const { Option } = Select;

  useEffect(() => {
    if (!selectedItem) {
      editForm.resetFields();
      return;
    }

    editForm.setFieldsValue({
      task_id: selectedItem?.task_id,
      task_name: selectedItem?.task_name,
      process_id: selectedItem?.process_id,
      process_name: selectedItem?.process_name,
      relation_with: selectedItem?.relation_with,
      responsible_person_id: selectedItem?.responsible_person_id,
      responsible_person_name: selectedItem?.responsible_person_name,
      days: selectedItem?.days,
    });
  }, [selectedItem, editForm, isDrawerOpen]);

  const onSelectTask = (taskId) => {
    const task = TNATaskList?.find((item) => item?.id === taskId);

    editForm.setFieldsValue({
      task_name: task?.title,
      process_id: task?.process?.id || task?.tna_process_id,
      process_name: task?.process?.title,
      relation_with: task?.relation_with,
    });
  };

  const onSubmit = (values) => {
    const payload = {
      task_id: values?.task_id,
      task_name: values?.task_name,
      process_id: values?.process_id,
      process_name: values?.process_name,
      relation_with: values?.relation_with,
      responsible_person_id: values?.responsible_person_id,
      responsible_person_name: values?.responsible_person_name,
      days: values?.days,
      calculation_method: "Backward from PCD",
    };

    if (selectedItem) {
      onUpdateItem(selectedItem?.index, payload);
      return;
    }

    onAddNewItem(payload);
    editForm.resetFields();
  };

  return (
    <Form form={editForm} layout="vertical" onFinish={onSubmit}>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item name="task_name" hidden />
          <Form.Item name="task_id" label="Task" rules={[{ required: true, message: "Task is required" }]}>
            <Select
              size="small"
              showSearch
              placeholder="Select task"
              optionFilterProp="children"
              onSearch={getTNATaskList}
              onSelect={onSelectTask}
            >
              {isArrayAndHasValue(TNATaskList) &&
                TNATaskList.map((item) => (
                  <Option key={item?.id} value={item?.id}>
                    {item?.title}
                  </Option>
                ))}
            </Select>
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item name="process_id" hidden />
          <Form.Item name="process_name" label="Process">
            <Input size="small" placeholder="Process" disabled />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item name="relation_with" label="Relation With">
            <Input size="small" placeholder="Relation with" disabled />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item
            name="days"
            label="Days"
            rules={[
              { required: true, message: "Days is required" },
              {
                validator: (_, value) => {
                  if (value === 0 || value || value === -0) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Days must be numeric"));
                },
              },
            ]}
          >
            <InputNumber style={{ width: "100%" }} size="small" />
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item name="responsible_person_name" hidden />
          <Form.Item
            name="responsible_person_id"
            label="Responsible Person"
            rules={[
              {
                required: true,
                message: "Responsible person is required",
              },
            ]}
          >
            <Select
              size="small"
              showSearch
              placeholder="Select responsible person"
              optionFilterProp="children"
              onSearch={getUserList}
              onSelect={(userId) => {
                const user = userList?.find((item) => item?.id === userId);
                editForm.setFieldValue("responsible_person_name", user?.name);
              }}
            >
              {isArrayAndHasValue(userList) &&
                userList.map((item) => (
                  <Option key={item?.id} value={item?.id}>
                    {item?.name}
                  </Option>
                ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={8}>
        <Col span={12}>
          <Button style={{ width: "100%" }} type="primary" htmlType="submit" size="small">
            {selectedItem ? "Update" : "Add"}
          </Button>
        </Col>
        <Col span={12}>
          <Button style={{ width: "100%" }} size="small" danger onClick={closeDrawer}>
            Cancel
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default ItemEdit;
